import { CALL_API } from '../../../middleware/api';
import * as UzdtActions from '../usdt';
// function fetchRechargeUzcard(data) {
//     return {
//         type: ActionType.FETCH_RECHARGE_UZCARD,
//         [CALL_API]: {
//             endpoint: '/payment/uzcard/create-invoice',
//             method: 'post',
//             types: [ActionType.SUCCESS_FETCH_RECHARGE_UZCARD, ActionType.FAILURE_FETCH_RECHARGE_UZCARD],
//             credentials: true,
//             data
//         }
//     };
// }
export function createWalletUzdt(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: UzdtActions.CREATE_WALLET_USDT
            },
            _a[CALL_API] = {
                endpoint: "/payment/crypto",
                method: "post",
                credentials: true,
                types: [UzdtActions.SUCCESS_CREATE_WALLET_USDT, UzdtActions.FAILURE_CREATE_WALLET_USDT],
                data: data
            },
            _a));
    };
}
export function checkStatusUzdtWallet(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: UzdtActions.FETCH_STATUS_CREATED_USDT
            },
            _a[CALL_API] = {
                endpoint: "/payment/crypto/check/".concat(data.requestId),
                credentials: true,
                types: [UzdtActions.SUCCESS_FETCH_STATUS_CREATED_USDT, UzdtActions.FAILURE_FETCH_STATUS_CREATED_USDT],
                method: "get",
            },
            _a));
    };
}
export function clearUsdtState() {
    return function (dispatch) { return dispatch({
        type: UzdtActions.CLEAR_USDT_STATE,
    }); };
}



// WEBPACK FOOTER //
// ./src/actions/recharge/creators/usdt.js